var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrows/arrow-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.14941 12C2.14941 11.5858 2.4852 11.25 2.89941 11.25H20.8994C21.3136 11.25 21.6494 11.5858 21.6494 12C21.6494 12.4142 21.3136 12.75 20.8994 12.75H2.89941C2.4852 12.75 2.14941 12.4142 2.14941 12Z",
    fill: "#1C1B1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.42973 5.46967C9.72262 5.76256 9.72262 6.23744 9.42973 6.53033L3.96007 12L9.42973 17.4697C9.72262 17.7626 9.72262 18.2374 9.42973 18.5303C9.13683 18.8232 8.66196 18.8232 8.36907 18.5303L2.36908 12.5303C2.07619 12.2374 2.07619 11.7626 2.36908 11.4697L8.36907 5.46967C8.66196 5.17678 9.13683 5.17678 9.42973 5.46967Z",
    fill: "#1C1B1E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftLine);
export default __webpack_public_path__ + "static/media/arrow-left-line.61de90fee8918c2b7ec9e66cf503acad.svg";
export { ForwardRef as ReactComponent };